import React from "react";

const ProjectDetails = (props) => {
  const { project, index, marginClassName, handleShow } = props;
  return (
    <div
      className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
      onClick={() => handleShow(project)}
    >
      <div className={"container-lg ".concat(marginClassName)}>
        <a className="btn-default btn-block addWordBreak">
          <div className="row">
            <div className="col-md-4 col-lg-4">
              <u>
                <b>{project.title}</b>
              </u>
            </div>
            <div className="col-md-6 col-lg-6">
              ({project.technologiesHeading})
            </div>
            <div className="col-md-2 col-lg-2">{project.experience}</div>
          </div>{" "}
        </a>
      </div>
    </div>
  );
};
export default ProjectDetails;



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/careers/ProjectDetails/ProjectDetails.js